import { useLayoutContext } from "client/components/layout"
import { useIsChatHidden } from "client/packages/utils/useActivePlugins"
import { useEffect } from "react"
import { RozyLayout } from "shared/constants/views"

import { ChatView } from "../constants"

import { useChatContext } from "./ChatContext"
import ChatUi from "./chatUi"

// This component exists to set up ChatContext depending on
// our outer implementation (PluginContext, LayoutContext)
// This helps keep ChatContext independent from our layout & plugin contexts.

const Chat = () => {
  const { layout } = useLayoutContext()
  const { setIsChatOpen, setIsMobileView, setChatView } = useChatContext()

  const isChatHidden = useIsChatHidden()

  // Keep some ChatContext stuff in-sync with layout changes
  useEffect(() => {
    const view =
      layout === RozyLayout.MOBILE ? ChatView.OVERLAY : ChatView.DEFAULT

    // TODO these 2 can probably be combined? Or removed altogether & we just use `layout` directly
    setChatView(view)
    setIsMobileView(layout === RozyLayout.MOBILE)

    // If we go from mobile to default, set isChatOpen (mobile-only) to false
    if (layout !== RozyLayout.MOBILE) {
      setIsChatOpen(false)
    }
  }, [layout])

  if (isChatHidden) {
    return null
  }

  return <ChatUi />
}

export { Chat }
